// extracted by mini-css-extract-plugin
export default {"relative-container":"Main_relative-container__WYRy5","main-container":"Main_main-container__xNGPx","joker-info-container":"Main_joker-info-container__q+vTJ"};